import { isString } from 'lodash'
import { useTranslation } from '../../../../../translations'
import { useApplicationCallbacks } from '../../../../../providers/application-callbacks'
import { BUTTONS, IMAGE, TEXT, TITLE } from '../../../../modals/universalModal'
import { FRIENDS } from '../../../../../constants/shared/states/names'
import { useContent, useWishes } from '../../../../../redux/reducer/content'
import { useUser } from '../../../../../redux/reducer/user'
import content from '../../constants/content'
import useSetTimeout from '../../../../../hooks/useSetTimeout'
import { useModal } from '../../../../../hooks/useModal'

const { modalForId } = content

export default function useModalsAfterEnd() {
  const { data: wishData } = useWishes()
  const {
    profile: { wishAvailable },
  } = useUser()
  const {
    viewedFriend: { uid: userUid, username },
  } = useContent()
  const callbacks = useApplicationCallbacks()
  const { t } = useTranslation()
  const createTimeout = useSetTimeout()
  const { closeModal, addModal } = useModal()

  return () => {
    const idModal = {
      type: 'wishModal',
      props: {
        ...modalForId,
        onSubmit({ id } = {}) {
          isString(id) && callbacks.getWishUserData(id)
        },
      },
    }

    const modalAfterEnd = {
      type: 'universalModal',
      props: {
        modalProps: { wrapper: { isFullPage: false }, modifier: 'noFullNoScroll' },
        components: [
          {
            list: [
              {
                type: IMAGE,
                props: {
                  modifier: ['width-full', 'rounded'],
                  img: wishData?.elf?.image,
                },
              },
              {
                type: TITLE,
                props: { modifier: 'padding-no', value: 'wishContent.postcardSent' },
              },
              {
                type: TEXT,
                props: {
                  isUseTranslation: false,
                  value: `${t('other.consumer')}\n${username} (id${userUid})`,
                },
              },
              {
                type: BUTTONS,
                props: {
                  buttons: [
                    !!wishAvailable && {
                      text: 'other.sendMore',
                      className: 'custom-button wish-gift-card__button',
                      callbackKey: 'resetWishData',
                      onClick() {
                        closeModal('all')
                        createTimeout(() => addModal(idModal), 300)
                      },
                    },
                    {
                      text: 'other.continue',
                      className: 'custom-button_gray wish-gift-card__button',
                      redirect: FRIENDS,
                      modalData: { action: 'close', data: { type: 'all' } },
                    },
                  ].filter(Boolean),
                },
              },
            ],
          },
        ],
      },
    }

    createTimeout(() => addModal(modalAfterEnd), 300)
  }
}
